<script>
import MenuCard from '@/components/MenuCard'

export default {
  name: 'MenuGroupSelection',
  components: {
    MenuCard,
  },
  props: {
    groups: {
      type: Array,
      required: true,
    },
  },
  methods: {
    goNext(name) {
      const grp = this.groups.find(x => x.name === name)
      if (grp) return this.$emit('menus', grp)
    },

    getDescription(name) {
      const grp = this.groups.find(x => x.name === name)
      if (grp) return grp.description
    },
  },
}
</script>

<template>
  <v-row>
    <v-col cols="6">
      <MenuCard
        name="根元染め/リタッチ"
        :description="getDescription('リタッチ')"
        @click="goNext('リタッチ')"
      />
    </v-col>
    <v-col cols="6">
      <v-row>
        <v-col cols="12">
          <MenuCard
            name="全体染め(ショート)"
            :description="getDescription('全体染め(ショート)')"
            @click="goNext('全体染め(ショート)')"
          />
        </v-col>
        <v-col cols="12">
          <MenuCard
            name="全体染め(ミディアム)"
            :description="getDescription('全体染め(ミディアム)')"
            @click="goNext('全体染め(ミディアム)')"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="6">
      <MenuCard
        name="部分染め"
        :description="getDescription('部分染め')"
        @click="goNext('部分染め')"
      />
    </v-col>
    <v-col cols="6">
      <MenuCard
        name="全体染め(ロング)"
        :description="getDescription('全体染め(ロング)')"
        @click="goNext('全体染め(ロング)')"
      />
    </v-col>
    <v-col cols="6">
      <MenuCard
        name="ヘアカラーなし"
        :description="getDescription('ヘアカラーなし')"
        @click="goNext('ヘアカラーなし')"
      />
    </v-col>
    <v-col cols="6">
      <MenuCard
        name="全体染め(スーパーロング)"
        :description="getDescription('全体染め(スーパーロング)')"
        @click="goNext('全体染め(スーパーロング)')"
      />
    </v-col>
  </v-row>
</template>
